import script from "./ServiceContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceContent.vue?vue&type=script&setup=true&lang=js"

import "./ServiceContent.vue?vue&type=style&index=0&id=8001fd5c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8001fd5c"]])

export default __exports__